import { reportsConstants } from "../../constants/client";

const initialState = {};

export default function reports(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case reportsConstants.LISTING_REQUEST:
      currentstate = {
        loading: true
      };
      break;
    case reportsConstants.LISTING_SUCCESS:
      currentstate = {
        loading: false
      };
      break;
    case reportsConstants.LISTING_FAILURE:
      currentstate = { error: action.payload, loading: false };
      break;

    case reportsConstants.CONFIG_LISTING_REQUEST:
      currentstate = {
        paginationOptions: null,
        list: null,
        configLoading:true
      };
      break;
    case reportsConstants.CONFIG_LISTING_SUCCESS:
      currentstate = {
        list: action.payload.list,
        paginationOptions: action.payload.paginationOptions,
        configLoading:false
      };
      break;


    case reportsConstants.CONFIG_SAVE_REQUEST:
      currentstate = {
        update_required:false
      };
      break;
    case reportsConstants.CONFIG_SAVE_SUCCESS:
      currentstate = {
        update_required:true
      };
      break;


    case reportsConstants.CONFIG_DELETE_REQUEST:
      currentstate = {
        update_required:false
      };
      break;
    case reportsConstants.CONFIG_DELETE_SUCCESS:
      currentstate = {
        update_required:true
      };
      break;


    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
